import { ACSKey, SerializedACSContainer } from './ACSTypes';

export abstract class ACSCache {
  // Helper method to determine if cache can be used in given environment
  public static canUse(): boolean {
    return true;
  }

  public abstract set(serializedContainer: SerializedACSContainer): Promise<void>;

  public abstract get(key: ACSKey): Promise<SerializedACSContainer | null>;

  public abstract getAllKeys(): Promise<ACSKey[]>;

  public abstract has(key: ACSKey): Promise<boolean>;

  public abstract remove(key: ACSKey): Promise<void>;

  public abstract clear(): Promise<void>;
}
